module.exports = __webpack_public_path__ + "img/style2_platform_logo_en_c6169b439.png";